import React from "react";
import DashboardPage from "../pages/DashboardPage";
import RolesAndPermissionsPage from "../pages/RolesAndPermissionsPage";
import BranchesPage from "../pages/BranchesPage";
import UsersPage from "../pages/UsersPage";
import AccountsPage from "../pages/AccountsPage";
import CategoriesPage from "../pages/CategoriesPage";
import QuantityUnitsPage from "../pages/QuantityUnitsPage";
import PackageUnitsPage from "../pages/PackageUnitsPage";
import PaymentMethodsPage from "../pages/PaymentMethodsPage";
import TaxCodesPage from "../pages/TaxCodesPage";
import AuditLogsPage from "../pages/AuditLogsPage";
import ExpenseCategoriesPage from "../pages/ExpenseCategoriesPage";
import CurrenciesPage from "../pages/CurrenciesPage";
import ItemsPage from "../pages/ItemsPage";
import StockLevelsPage from "../pages/StockLevelsPage";
import InventoryLogsPage from "../pages/InventoryLogsPage";
import BrandsPage from "../pages/BrandsPage";
import ShiftsPage from "../pages/ShiftsPage";
import PosPage from "../pages/PosPage";
import SalesPage from "../pages/SalesPage";
import ReceiptsPage from "../pages/ReceiptsPage";
import CustomersPage from "../pages/CustomersPage";
import SuppliersPage from "../pages/SuppliersPage";
import ReceiptPage from "../pages/ReceiptPage";
import PurchaseOrdersPage from "../pages/PurchaseOrdersPage";
import PurchaseOrderPage from "../pages/PurchaseOrderPage";
import CreatePurchaseOrderPage from "../pages/CreatePurchaseOrderPage";
import InvoicesPage from "../pages/InvoicesPage";
import InvoicePage from "../pages/InvoicePage";
import CreditNotesPage from "../pages/CreditNotesPage";
import CreditNotePage from "../pages/CreditNotePage";
import DebtsPage from "../pages/DebtsPage";
import DebtPage from "../pages/DebtPage";
import ExpensesPage from "../pages/ExpensesPage";
import AnnouncementsPage from "../pages/AnnouncementsPage";
import NotificationsPage from "../pages/NotificationsPage";
import SmsTemplatesPage from "../pages/SmsTemplatesPage";
import SmsOutboxPage from "../pages/SmsOutboxPage";
import PaymentsPage from "../pages/PaymentsPage";
import LedgerEntriesPage from "../pages/LedgerEntriesPage";
import SequencesPage from "../pages/SequencesPage";
import DocumentHeadersPage from "../pages/DocumentHeadersPage";
import CompanyChargesPage from "../pages/CompanyChargesPage";
import QuotationsPage from "../pages/QuotationsPage";
import QuotationPage from "../pages/QuotationPage";
import BiPage from "../pages/BiPage";
import WhatsappPage from "../pages/WhatsappPage";

// --- 1. Define the Placeholder as a reusable component ---
const Placeholder = ({ title }: { title?: string }): React.ReactElement => (
  <div style={{ padding: "2rem" }}>
    <h1>{title || "Page Under Construction"}</h1>
  </div>
);

// --- 2. All entries must be component references, not functions ---
const RouteToComponentMapper: Record<string, React.ElementType> = {
  DASHBOARD: DashboardPage,

  // Sales
  POS: PosPage,
  SALES: SalesPage,
  SHIFTS: ShiftsPage,
  RECEIPTS: ReceiptsPage,
  RECEIPT: ReceiptPage,
  INVOICES: InvoicesPage,
  INVOICE: InvoicePage,
  CUSTOMER_ORDERS: Placeholder,
  CREDIT_NOTES: CreditNotesPage,
  CREDIT_NOTE: CreditNotePage,
  QUOTATIONS: QuotationsPage,
  QUOTATION: QuotationPage,

  // Inventory
  ITEMS: ItemsPage,
  CATEGORIES: CategoriesPage,
  BRANDS: BrandsPage,
  STOCK_LEVELS: StockLevelsPage,
  PACKAGE_UNITS: PackageUnitsPage,
  QUANTITY_UNITS: QuantityUnitsPage,
  INVENTORY_LOGS: InventoryLogsPage,

  // Procurement
  PURCHASE_ORDERS: PurchaseOrdersPage,
  PURCHASE_ORDER_CREATE: CreatePurchaseOrderPage,
  PURCHASE_ORDER: PurchaseOrderPage,
  SUPPLIERS: SuppliersPage,

  // CRM
  CUSTOMERS: CustomersPage,
  CUSTOMER_USERS: Placeholder,

  // Finance
  ACCOUNTS: AccountsPage,
  EXPENSES: ExpensesPage,
  EXPENSE_CATEGORIES: ExpenseCategoriesPage,
  DEBTS: DebtsPage,
  DEBT: DebtPage,
  PAYMENTS: PaymentsPage,
  LEDGER_ENTRIES: LedgerEntriesPage,

  // Comms
  ANNOUNCEMENTS: AnnouncementsPage,
  NOTIFICATIONS: NotificationsPage,
  SMS_TEMPLATES: SmsTemplatesPage,
  SMS_OUTBOX: SmsOutboxPage,
  WHATSAPP_CONVERSATION: WhatsappPage,

  // Admin
  BI: BiPage,
  BRANCHES: BranchesPage,
  USERS: UsersPage,
  ROLES: RolesAndPermissionsPage,
  CURRENCIES: CurrenciesPage,
  TAX_CODES: TaxCodesPage,
  COMPANY_CHARGES: CompanyChargesPage,
  PAYMENT_METHODS: PaymentMethodsPage,
  DOCUMENT_HEADERS: DocumentHeadersPage,
  SEQUENCES: SequencesPage,
  AUDIT_LOGS: AuditLogsPage,
};

export default RouteToComponentMapper;
